import { createFileRoute } from '@tanstack/react-router';

import { buildGuards, hasFlagEnabled } from '@mint-lib/routing-guards';
import * as DataIngestion from '@mint-sdk/api-data-ingestion';

import { PendingComponent } from '@myn/import-hub/routes';

const dataFilePreloadGuard = buildGuards(hasFlagEnabled('dataFilePreload'));
const importHubV2Guard = buildGuards(hasFlagEnabled('importHubV2'));

export const Route = createFileRoute(
  '/_secured/company-profile/import-hub/performance/imports/$dataFileId/headers-mapping',
)({
  staleTime: 30 * 1000,
  loader: async ({ context, params, cause }) => {
    const armGuardsContext = await context.getGuardContext(
      await context.getInstance('flagsmith', '@mint/arm'),
    );

    if (!dataFilePreloadGuard(armGuardsContext) || cause !== 'preload') {
      return;
    }

    const isImportHubV2 = importHubV2Guard(armGuardsContext);

    const queryClient =
      await context.serviceLocator.getOrThrowInstance('queryClient');

    const dataFilePreviewV1QueryOptions =
      DataIngestion.DataFile.getTableDataFilePreviewV1QueryOptions({
        urlParams: { id: params.dataFileId },
      });

    const dataFilePreviewV2QueryOptions =
      DataIngestion.DataFile.getTableDataFilePreviewV2QueryOptions({
        urlParams: { id: params.dataFileId },
      });

    const dataFilePreview = isImportHubV2
      ? await queryClient.ensureQueryData(dataFilePreviewV2QueryOptions)
      : await queryClient.ensureQueryData(dataFilePreviewV1QueryOptions);

    queryClient.prefetchQuery(
      DataIngestion.DataFile.getDataFileFormatsQueryOptions({
        urlParams: { id: params.dataFileId },
      }),
    );

    queryClient.prefetchQuery(
      DataIngestion.DataFile.getHeadersMappingQueryOptions({
        urlParams: { id: params.dataFileId },
      }),
    );

    const systemMetricsV1QueryOptions =
      DataIngestion.SystemMetrics.getSystemMetricsQueryOptions({
        params: {
          granularityLevelType: dataFilePreview.granularityLevel,
        },
      });
    const systemMetricsV2QueryOptions =
      DataIngestion.SystemMetrics.getDataFileSystemMetricsQueryOptions({
        urlParams: { id: params.dataFileId },
        params: {
          granularityLevelType: dataFilePreview.granularityLevel,
        },
      });

    if (isImportHubV2) {
      queryClient.prefetchQuery(systemMetricsV2QueryOptions);
    } else {
      queryClient.prefetchQuery(systemMetricsV1QueryOptions);
    }
  },
  pendingComponent: PendingComponent,
});
